export const MODULE_NAME = 'AUTH_MODULE';
